import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-address-retry-continue-options',
  templateUrl: './address-retry-continue-options.component.html',
  styleUrls: ['./address-retry-continue-options.component.scss']
})
export class AddressRetryContinueOptionsComponent implements OnInit {
  @Output() retryEmitter = new EventEmitter<Boolean>();
  constructor() { }

  ngOnInit(): void {
  }

}
